export default __webpack_public_path__ + "static/media/6-min.3da25207.jpg";